export default __webpack_public_path__ + "static/media/login.2936e4d0.png";